import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { fadeIn } from '../styles/animations';

export const HeroSection = () => {
  return (
    <Container sx={{ paddingBottom: '50px' }}>
      <Box
        sx={{
          minHeight: '90vh',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          paddingTop: '60px',
          position: 'relative',
        }}
      >
        {/* Background Logo */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ amount: 0.3 }}
          variants={fadeIn}
          transition={{ duration: 0.5 }}
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1,
          }}
        >
          <Box
            component="img"
            src="/fantasy_mma_logo.png"
            alt="Background Logo"
            sx={{
              width: 'auto',
              height: '300px',
              opacity: 0.15,
              filter: 'blur(2px)',
            }}
          />
        </motion.div>

        {/* Text Content */}
        <Box sx={{ position: 'relative', zIndex: 2 }}>
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3 }}
            variants={fadeIn}
            transition={{ duration: 0.5 }}
          >
            <Typography
              variant="h1"
              sx={{
                fontFamily: 'Rubik Mono One',
                fontStyle: 'italic',
                fontSize: 'clamp(2rem, 5vw, 4rem)',
                color: '#ffffff',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.3)',
                  filter: 'blur(8px)',
                  zIndex: -1,
                },
              }}
            >
              Fantasy MMA
            </Typography>
          </motion.div>

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ amount: 0.3 }}
            variants={fadeIn}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: 'clamp(1rem, 2vw, 1.5rem)',
                color: '#cc0000',
                marginBottom: '40px',
                fontFamily: 'Rubik Mono One',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(0, 0, 0, 0.3)',
                  filter: 'blur(8px)',
                  zIndex: -1,
                },
              }}
            >
              Build Your Ultimate Fighting Team
            </Typography>
          </motion.div>
        </Box>
      </Box>
    </Container>
  );
};
